import { medal_create, medal_update } from '../redux/actions/medalsActions';

export const WORLD_MEDAL_TYPE = 2;
export const MEDAL_TIER_SILVER = 2;
export const MEDAL_TIER_GOLD = 3;

// Resolve a raw mongo reference ({$oid}, populated doc or plain id) to a string id.
export const object_ref_id = (ref) => (
	ref?.$oid ?? ref?._id?.$oid ?? ref?._id ?? ref ?? null
);

// Find the world's Silver/Gold medals from a flat medals list.
export const world_tier_medals = (medals, worldId) => {
	const list = medals || [];

	const matches = (medal, tier) => (
		medal.medal_type === WORLD_MEDAL_TYPE &&
		medal.medal_tier === tier &&
		object_ref_id(medal.world) === worldId
	);

	return {
		silver: list.find((m) => matches(m, MEDAL_TIER_SILVER)) ?? null,
		gold: list.find((m) => matches(m, MEDAL_TIER_GOLD)) ?? null,
	};
};

export const build_world_medal_body = ({ worldId, tier, name, description }) => ({
	name,
	description,
	medal_type: WORLD_MEDAL_TYPE,
	medal_tier: tier,
	world: worldId,
	value: 0,
});

// Create (no existing id) or update the world's tier medal.
export const upsert_world_medal = (
	dispatch, messageApi, { existing, worldId, tier, name, description }, onDone
) => {
	const body = build_world_medal_body({ worldId, tier, name, description });

	const existingId = object_ref_id(existing);

	if (existingId) {
		dispatch(medal_update(messageApi, existingId, body, onDone));
	}
	else {
		dispatch(medal_create(body, onDone));
	}
};
